import { createSelector } from '@ngrx/store';

import { featureKey } from '../definitions';
import { LocaleState } from './state';

export const selectLocaleState = createSelector(
  (appState: any) => appState[featureKey],
  (state: LocaleState) => state
);
